<template>
  <div class="w-100">
    <b-form-group
      :label="showLabel ? 'Empresa' : null"
      :class="!showLabel ? 'mb-0' : ''"
    >
      <validation-provider
        #default="{ errors }"
        :rules="{required: require_}"
        name="Empresa"
      >
        <v-select
          ref="empresaSelect"
          v-model="value_"
          class="empresa-select"
          :options="empresas"
          label="razaoSocial"
          :clearable="false"
          :multiple="multiple"
          :disabled="disabled"
          @close="onTouch"
          @open="carregarEmpresas"
          @search-change="carregarEmpresasFiltradas"
          @input="enviarParaPai"
        >
          <template #selected-option="{ razaoSocial }">
            <span>{{ razaoSocial }}</span>
          </template>
          <template v-slot:option="option">
            <div class="company-identification">
              <span>{{ option.cadastroFederal }}</span>
            </div>
            <span style="line-break: auto; width: calc(100%);white-space: pre-wrap;">{{ option.razaoSocial }}</span>
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

  </div>
</template>

<style lang="scss">
.empresa-select .vs__dropdown-option--selected .company-identification {
  & span {
    color: white;
    border: 1px solid white !important;
  }
}
.company-identification {
  & span {
    font-size: 0.65rem;
    color: var(--primary);
    font-weight: 700;
    background-color: transparent;
    border: 1px solid var(--primary) !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}
</style>

<script>
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import api from './shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'EmpresaUsuarioSelect',
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    description: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
  },
  data() {
    return {
      required,
      valueAttr: null,
      foiAcessado: false,
      empresas: [],
      primeiroAcesso: true,
      filtros: [
        {
          colunas: ['empresaNome'],
          valor: null,
        },
      ],
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(value) {
        this.valueAttr = value
      },
    },
    isInvalid() {
      return this.invalid && this.foiAcessado
    },
    require_: {
      get() {
        return this.require
      },
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = val
      }
    },
  },
  methods: {
    carregarEmpresas() {
      if (this.primeiroAcesso) {
        api.getEmpresasUsuario(this.filtros)
          .then(payload => {
            this.empresas = payload.data
            this.primeiroAcesso = false
          })
          .catch(err => {
            this.$errorFormated(err.response)
            throw err
          })
      }
    },
    carregarEmpresasFiltradas(value) {
      this.filtros[0].valor = value
      api.getEmpresasUsuario(this.filtros)
        .then(payload => {
          this.empresas = payload.data
        })
        .catch(err => {
          this.$errorFormated(err.response)
          throw err
        })
    },
    propagarParaFilho() {
      this.$refs.empresaSelect.focus()
    },
    enviarParaPai() {
      // eslint-disable-next-line no-underscore-dangle
      this.$emit('select', !this.value_ ? null : this.value_)
      // eslint-disable-next-line no-underscore-dangle
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    onTouch() {
      this.foiAcessado = true
    },
    limpar() {
      // eslint-disable-next-line no-underscore-dangle
      this.value_ = []
    },
  },
}
</script>
